// extracted by mini-css-extract-plugin
export default {"container":"About_container__PW2E6","support":"About_support__tbMxq"};